import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2b0442fe&scoped=true"
import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=2b0442fe&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0442fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\tx_projects\\plat-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b0442fe')) {
      api.createRecord('2b0442fe', component.options)
    } else {
      api.reload('2b0442fe', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2b0442fe&scoped=true", function () {
      api.rerender('2b0442fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/application/routine/deliveryManagement/index.vue"
export default component.exports